export const countriesAllowedToRefundAndCancellation = ["US", "AU"] as const;

export function isCountryAllowedToRefundAndCancellation(
  countryCode?: string | null,
) {
  return countriesAllowedToRefundAndCancellation.includes(
    countryCode?.toUpperCase() as (typeof countriesAllowedToRefundAndCancellation)[number],
  );
}
